var _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 10,
    width: 1,
    height: 12,
    rx: 0.5,
    fill: "black",
    fillOpacity: 0.85
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.375,
    y: 9.875,
    width: 1.25,
    height: 12.25,
    rx: 0.625,
    stroke: "black",
    strokeOpacity: 0.85,
    strokeWidth: 0.25
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 16.5,
    width: 1,
    height: 12,
    rx: 0.5,
    transform: "rotate(-90 10 16.5)",
    fill: "black",
    fillOpacity: 0.85
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9.875,
    y: 16.625,
    width: 1.25,
    height: 12.25,
    rx: 0.625,
    transform: "rotate(-90 9.875 16.625)",
    stroke: "black",
    strokeOpacity: 0.85,
    strokeWidth: 0.25
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 30.5,
    height: 30.5,
    rx: 15.25,
    stroke: "black",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCPlus);
export default __webpack_public_path__ + "static/media/c-plus.da2fbac95af1c591724d1fd131976e86.svg";
export { ForwardRef as ReactComponent };